(function () {
    "use strict";

    function passwordVisibilityToggle() {
        document.querySelectorAll('.password-container.has-toggle').forEach(function (container) {
            var button = container.querySelector('.password-toggle-button');
            if (!button) {
                button = document.createElement('button');
                button.type = 'button';
                button.className = 'password-toggle-button';
                button.setAttribute('aria-label', 'Toggle password visibility');
                container.appendChild(button);
            }
            button.addEventListener('click', function () {
                var input = container.querySelector('input[type="password"], input[type="text"]');
                if (!input) return;
                input.type = input.type === 'password' ? 'text' : 'password';
                container.classList.toggle("show-password");
            });
        });
    }

    document.addEventListener("DOMContentLoaded", passwordVisibilityToggle);
})();
